

































import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import BackHomeOrExit from '@/mixins/BackHomeOrExit';
import BusinessStockImage from '@/mixins/BusinessStockImage';
import EntityPage from '@/components/EntityPage.vue';
import BusinessOverview from './BusinessOverview/index.vue';
import BusinessReviews from './BusinessReviews.vue';
import gql from 'graphql-tag';

interface IDetails {
  __typename: string;
  id: string;
  name: string;
  active: boolean;
  mall?: {
    __typename: string;
    id: string;
    name: string;
  };
  level: string;
  unit: string;
  address: string;
  description?: string;
  phone?: number;
  pricing?: number;
  rating?: number;
}

export default mixins(BackHomeOrExit, BusinessStockImage)
  .extend({
    name: 'Business',
    props: {
      bizId: {
        type: String as PropType<string>,
        required: true,
      },
    },
    data() {
      return {
        details: undefined as void | IDetails,
      };
    },
    computed: {
      bizName(): string {
        return (this.details && this.details.name) || '';
      },
      bizImage(): string {
        return this.generateBizStockImage(this.bizId);
      },
    },
    watch: {
      details() {
        if (this.details === null) {
          this.$router.replace({ name: '404' });
        }
      },
    },
    methods: {
      onTabChange(val: number) {
        this.tab = val;
      },
    },
    components: {
      EntityPage,
      BusinessOverview,
      BusinessReviews,
    },
  })
  .extend({
    apollo: {
      details: {
        query: gql`
          query getBusinessDetails($businessID: ID!) {
            findBusinessByID(id: $businessID) {
              id: _id
              name
              active
              mall {
                id: _id
                name
              }
              level
              unit
              address
              description
              phone
              pricing
              rating
            }
          }
        `,
        variables() {
          return {
            businessID: this.bizId,
          };
        },
        update(data) {
          return data.findBusinessByID;
        },
      },
    },
  });
